import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

import {TPlace} from '../../Definitions';
import TypeIcon from '../TypeIcon';

type TPoiMarkerProps = TPlace & {
    lat: number;
    lng: number;
    isActive: boolean;
}
export default (place: TPoiMarkerProps) => {
    const isExtended = Boolean(place.poi);

    return (
        <div className={classNames(
            styles.requiredMarkerStyles,
            styles.poiMarker,
            place.isActive && styles.isActive,
        )}>
            {
                place.icon &&
                    <TypeIcon icon={place.icon}/>
            }
            <div className={styles.label}>
                {place.name}
            </div>
        </div>
    );
}
